export const formatNumber = (value, fixedValue) => {
  if (typeof value === "number" || typeof value === "string") {
    return +value.toFixed(fixedValue);
  } else {
    return null;
  }
};
